// Generated by BUCKLESCRIPT VERSION 1.9.3, PLEASE EDIT WITH CARE
'use strict';

var Block       = require("bs-platform/lib/js/block.js");
var Curry       = require("bs-platform/lib/js/curry.js");
var React       = require("react");
var Video       = require("./video.mp4");
var ReasonReact = require("reason-react/lib/js/src/reasonReact.js");

((require('./videoPlayer.css')));

var component = ReasonReact.reducerComponent("VideoPlayer");

function setVideoRef(theRef, param) {
  param[/* state */4][/* video */0][0] = theRef === null ? /* None */0 : [theRef];
  return /* () */0;
}

function make() {
  var newrecord = component.slice();
  newrecord[/* render */9] = (function (self) {
      var match = self[/* state */4][/* isPlayingVideo */1];
      var control = match !== 0 ? "pause" : "play";
      var match$1 = self[/* state */4][/* isShowingModal */2];
      var modal = match$1 !== 0 ? "close" : "modal";
      var match$2 = self[/* state */4][/* isShowingModal */2];
      return React.createElement("div", {
                  className: "VideoPlayer"
                }, React.createElement("div", undefined, React.createElement("video", {
                          ref: Curry._1(self[/* handle */0], setVideoRef),
                          loop: true,
                          onClick: Curry._1(self[/* reduce */3], (function () {
                                  return /* ToggleVideo */0;
                                }))
                        }, React.createElement("source", {
                              src: Video,
                              type: "video/mp4"
                            })), React.createElement("aside", {
                          className: match$2 !== 0 ? "modal active" : "modal"
                        }, React.createElement("table", undefined, React.createElement("tbody", undefined, React.createElement("tr", undefined, React.createElement("td", undefined, "Title:"), React.createElement("td", undefined, "x marks the spot")), React.createElement("tr", undefined, React.createElement("td", undefined, "Author:"), React.createElement("td", undefined, "portal process")), React.createElement("tr", undefined, React.createElement("td", undefined, "Link:"), React.createElement("td", undefined, React.createElement("a", {
                                              href: "https://youtu.be/fpQnV_Bp7Jo",
                                              target: "_blank"
                                            }, "Youtube"))))))), React.createElement("nav", {
                      className: "controls"
                    }, React.createElement("a", {
                          onClick: Curry._1(self[/* reduce */3], (function () {
                                  return /* ToggleVideo */0;
                                }))
                        }, control), React.createElement("a", {
                          onClick: Curry._1(self[/* reduce */3], (function () {
                                  return /* ToggleModal */1;
                                }))
                        }, modal)));
    });
  newrecord[/* initialState */10] = (function () {
      return /* record */[
              /* video */[/* None */0],
              /* isPlayingVideo : false */0,
              /* isShowingModal : false */0
            ];
    });
  newrecord[/* reducer */12] = (function (action, state) {
      if (action !== 0) {
        if (state[/* isShowingModal */2]) {
          var match = state[/* video */0][0];
          if (match) {
            match[0].play();
          }
          return /* Update */Block.__(0, [/* record */[
                      /* video */state[/* video */0],
                      /* isPlayingVideo : true */1,
                      /* isShowingModal */1 - state[/* isShowingModal */2]
                    ]]);
        } else {
          var match$1 = state[/* video */0][0];
          if (match$1) {
            match$1[0].pause();
          }
          return /* Update */Block.__(0, [/* record */[
                      /* video */state[/* video */0],
                      /* isPlayingVideo : false */0,
                      /* isShowingModal */1 - state[/* isShowingModal */2]
                    ]]);
        }
      } else {
        if (state[/* isPlayingVideo */1]) {
          var match$2 = state[/* video */0][0];
          if (match$2) {
            match$2[0].pause();
          }
          
        } else {
          var match$3 = state[/* video */0][0];
          if (match$3) {
            match$3[0].play();
          }
          
        }
        return /* Update */Block.__(0, [/* record */[
                    /* video */state[/* video */0],
                    /* isPlayingVideo */1 - state[/* isPlayingVideo */1],
                    /* isShowingModal : false */0
                  ]]);
      }
    });
  return newrecord;
}

exports.component   = component;
exports.setVideoRef = setVideoRef;
exports.make        = make;
/*  Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/videoPlayer.re
// module id = 23
// module chunks = 0